import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const leadInMastery = {
    "blockId": uuidv4(),
    "description": "<p>This section focuses on the following competencies: <strong>Innovation, Dedication, Agility, and Challenge</strong>. Share how often you have experienced the leader demonstrating the below behaviors. Identify <strong>at least one behavior</strong> that the leader does not demonstrate often or always, as these highlight potential opportunities for growth. </p>",
    "selfDescription": "<p>This section focuses on the following competencies: <strong>Innovation, Dedication, Agility, and Challenge</strong>. Share how often you demonstrate the below behaviors. Identify <strong>at least one behavior</strong> you don't demonstrate often or always, as these highlight potential opportunities for growth. </p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }
    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                { "label": "Never", "value": "1" },
                { "label": "Rarely", "value": "2" },
                { "label": "Occasionally", "value": "3" },
                { "label": "Sometimes", "value": "4" },
                { "label": "Often", "value": "5" },
                { "label": "Always", "value": "6" },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                // Innovation
                {
                    "subCategoryId": generateStaticQuestionId("Innovation"),
                    "subCategory": "Innovation",
                    "staticQuestionId": generateStaticQuestionId("Encourages the use of collective problem solving and creativity to find solutions"),
                    "HTMLText": "<p>Encourages the use of collective problem solving and creativity to find solutions</p>",
                    "isSelected": true,
                    "text": "Encourages the use of collective problem solving and creativity to find solutions",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Innovation"),
                    "subCategory": "Innovation",
                    "staticQuestionId": generateStaticQuestionId("Generates new ideas and approaches to propel the organization forward"),
                    "HTMLText": "<p>Generates new ideas and approaches to propel the organization forward</p>",
                    "isSelected": true,
                    "text": "Generates new ideas and approaches to propel the organization forward",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Innovation"),
                    "subCategory": "Innovation",
                    "staticQuestionId": generateStaticQuestionId("Creates the time and space to nurture new ways of thinking"),
                    "HTMLText": "<p>Creates the time and space to nurture new ways of thinking</p>",
                    "isSelected": true,
                    "text": "Creates the time and space to nurture new ways of thinking",
                    "value": uuidv4()
                },

                // Dedication
                {
                    "subCategoryId": generateStaticQuestionId("Dedication"),
                    "subCategory": "Dedication",
                    "staticQuestionId": generateStaticQuestionId("Shows commitment to their craft"),
                    "HTMLText": "<p>Shows commitment to their craft</p>",
                    "isSelected": true,
                    "text": "Shows commitment to their craft",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Dedication"),
                    "subCategory": "Dedication",
                    "staticQuestionId": generateStaticQuestionId("Encourages learning through hands on experience, experimentation, and reflection"),
                    "HTMLText": "<p>Encourages learning through hands on experience, experimentation, and reflection</p>",
                    "isSelected": true,
                    "text": "Encourages learning through hands on experience, experimentation, and reflection",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Dedication"),
                    "subCategory": "Dedication",
                    "staticQuestionId": generateStaticQuestionId("Pushes others to strive for excellence"),
                    "HTMLText": "<p>Pushes others to strive for excellence</p>",
                    "isSelected": true,
                    "text": "Pushes others to strive for excellence",
                    "value": uuidv4()
                },

                // Agility
                {
                    "subCategoryId": generateStaticQuestionId("Agility"),
                    "subCategory": "Agility",
                    "staticQuestionId": generateStaticQuestionId("Adjusts short-term approaches to align with desired long-term outcomes"),
                    "HTMLText": "<p>Adjusts short-term approaches to align with desired long-term outcomes</p>",
                    "isSelected": true,
                    "text": "Adjusts short-term approaches to align with desired long-term outcomes",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Agility"),
                    "subCategory": "Agility",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates a willingness to learn and adapt"),
                    "HTMLText": "<p>Demonstrates a willingness to learn and adapt</p>",
                    "isSelected": true,
                    "text": "Demonstrates a willingness to learn and adapt",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Agility"),
                    "subCategory": "Agility",
                    "staticQuestionId": generateStaticQuestionId("Effectively navigates uncertainty or ambiguity"),
                    "HTMLText": "<p>Effectively navigates uncertainty or ambiguity</p>",
                    "isSelected": true,
                    "text": "Effectively navigates uncertainty or ambiguity",
                    "value": uuidv4()
                },

                // Challenge
                {
                    "subCategoryId": generateStaticQuestionId("Challenge"),
                    "subCategory": "Challenge",
                    "staticQuestionId": generateStaticQuestionId("Inspires and supports bold ideas"),
                    "HTMLText": "<p>Inspires and supports bold ideas</p>",
                    "isSelected": true,
                    "text": "Inspires and supports bold ideas",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Challenge"),
                    "subCategory": "Challenge",
                    "staticQuestionId": generateStaticQuestionId("Embraces constructive conflict with openness and curiosity"),
                    "HTMLText": "<p>Embraces constructive conflict with openness and curiosity</p>",
                    "isSelected": true,
                    "text": "Embraces constructive conflict with openness and curiosity",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Challenge"),
                    "subCategory": "Challenge",
                    "staticQuestionId": generateStaticQuestionId("Supports challenging the status quo"),
                    "HTMLText": "<p>Supports challenging the status quo</p>",
                    "isSelected": true,
                    "text": "Supports challenging the status quo",
                    "value": uuidv4()
                }
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "LEAD IN MASTERY"
}
